import React from 'react';
import styles from './toolbar.module.css';

interface SecondaryToolbarProps {
  children: React.ReactNode;
  /**
   * Break out of `.main-content`'s 10px padding so the bar is flush and
   * full-width under the nav. Default true (per-page rendering). Set false
   * when the bar is hoisted into the app chrome (no surrounding padding).
   */
  fullBleed?: boolean;
  /**
   * Horizontal content padding (px). Defaults to the kit's 22px. Set this to
   * the page's content gutter (main-content padding + the content container's
   * horizontal padding) so the toolbar's controls line up with the table/list
   * beneath it.
   */
  inset?: number;
  /**
   * Render as a floating card (margin + rounded + shadow, no border-bottom) on a
   * coloured page surface, instead of the flush full-bleed bar. Takes precedence
   * over `fullBleed`.
   */
  floating?: boolean;
}

/**
 * The contextual secondary toolbar shell. Render it as the FIRST child of a
 * page (before the page's padded content container) and compose the control
 * kit inside it — e.g. <ToolbarSearch/>, <ToolbarChip/>, <ToolbarSpacer/>,
 * <ToolbarDivider/>, <ToolbarButton/>.
 */
export const SecondaryToolbar: React.FC<SecondaryToolbarProps> = ({
  children,
  fullBleed = true,
  inset,
  floating = false,
}) => (
  <div
    className={`${styles.bar}${
      floating ? ` ${styles.barFloating}` : fullBleed ? ` ${styles.barFullBleed}` : ''
    }`}
    style={inset !== undefined ? { paddingLeft: inset, paddingRight: inset } : undefined}
  >
    {children}
  </div>
);
